import ApiClient from './ApiClient';

class FashFastService {
    private useLegacyEndpoints(): boolean {
        return process.env.REACT_APP_USE_LEGACY_AI_ENDPOINTS === 'true'
            || (typeof window !== 'undefined' && window.sessionStorage.getItem('FC_USE_LEGACY_AI_ENDPOINTS') === 'true');
    }

    /**
     * Set the brand ID override
     */
    public setBrandId(brandId: string | null): void {
        ApiClient.setBrandId(brandId);
    }

    /**
     * Validate the uploaded selfie via FashFast
     */
    public async validateSelfie(selfieImage: string): Promise<{ valid: boolean; error?: string; detectedGender?: 'male' | 'female' }> {
        const response = await ApiClient.post<{ valid: boolean; error?: string; detectedGender?: 'male' | 'female' }>(
            '/fash-fast/validate', 
            { selfieImage }
        );
        return response.data;
    }

    /**
     * Generate Try-On result
     */
    public async generateTryOn(
        selfieImage: string, 
        productId: string, 
        brandId: string, 
        userId: string,
        forceRegenerate: boolean = false
    ): Promise<string> {
        const response = await ApiClient.post<{ success?: boolean; status?: string; imageUrl: string }>(
            this.useLegacyEndpoints() ? '/fash-fast/generate' : '/media/try-on/fast/jobs',
            { selfieImage, productId, brandId, userId, forceRegenerate }
        );
        return response.data.imageUrl;
    }
}

const fashFastService = new FashFastService();
export default fashFastService;
